export default "__VITE_ASSET__e860a4cd__"